import { gql } from '@apollo/client';

const ENDPOINT = {
    GET_STANCER_ADD_CARD: gql`
        query getStancerAddCardSelfCareHpp {
            getStancerAddCardSelfCareHpp {
                url
                paymentIntentId
            }
        }
    `,
    VALIDATE_STANCER_ADD_CARD_SELFCARE_HPP: gql`
        mutation validateStancerAddCardSelfCareHpp($paymentIntentId: String!) {
            validateStancerAddCardSelfCareHpp(paymentIntentId: $paymentIntentId)
        }
    `,
    GET_STANCER_ONE_OFF_CARD: gql`
        query getStancerOneOffSelfCareHpp($paymentRequest: paymentRequest!) {
            getStancerOneOffSelfCareHpp(paymentRequest: $paymentRequest) {
                url
                paymentIntentId
            }
        }
    `,
    VALIDATE_STANCER_ONE_OFF_SELFCARE_HPP: gql`
        mutation validateStancerOneOffSelfCareHpp($hppResponse: hppResponse!) {
            validateStancerOneOffSelfCareHpp(hppResponse: $hppResponse)
        }
    `,
    GET_MY_PAYMENT_METHOD_DETAILS: gql`
        query getPaymentMethod($account_id: String!) {
            getPaymentMethod(account_id: $account_id) {
                accountId
                paymentMethods {
                    expirationDate
                    partialDigits
                    paymentMethodId
                    paymentMethodType
                    status
                    providerReference
                    type
                }
            }
        }
    `,
    VALIDATE_ONE_OFF_WITH_EXISTING_CARD: gql`
        mutation validateStancerOnceOffSelfcareExistingCard(
            $cardId: String!
            $paymentRequest: paymentRequest!
        ) {
            validateStancerOnceOffSelfcareExistingCard(
                paymentRequest: $paymentRequest
                cardId: $cardId
            )
        }
    `,
};

/**
 * @name getStancerAddCard - Get details for adding the card
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @returns {string} Promise resolves in to  add card response
 */
export const getStancerAddCard = async ({ graphql }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_STANCER_ADD_CARD,
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

/**
 * @name validateStancerAddCardHpp Validates Stancer Add card response
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} variables - Request parameters for graphql call
 * @returns {Promise<object>} Promise and resolves to add card response
 */
export const validateStancerAddCardHpp = async ({ graphql, variables = {} }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.VALIDATE_STANCER_ADD_CARD_SELFCARE_HPP,
            variables,
        });
        return data;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

/**
 * @name getStancerOneOffHpp - Get details for one off payment
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 *  @param {object} Obj.variables - Request parameters for graphql call
 * @returns {string} Promise resolves in to one off payment response
 */
export const getStancerOneOffHpp = async ({ graphql, variables = {} }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_STANCER_ONE_OFF_CARD,
            variables,
        });
        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

/**
 * @name validateStancerOneOffHpp Validates Stancer Add card response
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} variables - Request parameters for graphql call
 * @returns {Promise<object>} Promise and resolves to one off response
 */
export const validateStancerOneOffHpp = async ({ graphql, variables = {} }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.VALIDATE_STANCER_ONE_OFF_SELFCARE_HPP,
            variables,
        });
        return data;
    } catch (err) {
        throw err;
    }
};

/**
 * @name getPaymentMethods To get payment method info for CO/CS
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} variables - Request parameters for graphql call
 * @returns {Promise<object>} Promise and resolves to payment method details
 */
export const getPaymentMethods = async ({ graphql, variables = {} }) => {
    try {
        const resp = await graphql.query({
            query: ENDPOINT.GET_MY_PAYMENT_METHOD_DETAILS,
            variables,
        });
        return resp;
    } catch (err) {
        console.error(err);
        return err;
    }
};

/**
 * @name validateStancerOneOffHppExistingCard Validates Stancer existing card payment
 * @param {import('@apollo/client').ApolloClient<object>} graphql - Apollo client
 * @param {object} variables - Request parameters for graphql call
 * @returns {Promise<object>} Promise and resolves to one off response
 */
export const validateStancerOneOffHppExistingCard = async ({ graphql, variables = {} }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.VALIDATE_ONE_OFF_WITH_EXISTING_CARD,
            variables,
        });
        return { result: data, errors: null };
    } catch (error) {
        return { result: null, errors: { error } };
    }
};
